import React from 'react';
import OperationComponent from "./OperationComponent";
import {IPropsSearchItem, SEARCH_TYPE} from "./constants";
import VesselComponent from "./VesselComponent";
import SiteComponent from "./SiteComponent";
import FactoryComponent from "./FactoryComponent";

const SearchItemComponent: React.FC<IPropsSearchItem> = (props) => {
    const { field } = props.data;
    switch (field) {
        case SEARCH_TYPE.OPERATION:
            return <OperationComponent {...props} />
        case SEARCH_TYPE.VESSEL:
            return <VesselComponent {...props} />
        case SEARCH_TYPE.SITE:
            return <SiteComponent {...props} />
        case SEARCH_TYPE.FACTORY:
            return <FactoryComponent {...props} />
        default:
            return null;
    }
}

export default React.memo(SearchItemComponent);
